// ~~ Generated. This file cannot be edited directly. Please look at libs/nx-tooling/src/generators/backoffice-project/generator.ts

import { loadLazyWithTimeoutRetry } from '@backoffice-frontend/lazy-loading'
import { SuspenseLoadingWrapper } from '@backoffice-frontend/patterns'
import { BoumRight } from '@moia-dev/moia-token-claims'
import { lazy } from 'react'
import { FleetMaintenanceAreaId } from './FleetMaintenanceAreaId'
import { FleetMaintenanceAreaNavigation } from './FleetMaintenanceAreaNavigation'
import { FleetMaintenanceAreaRoutes } from './FleetMaintenanceAreaRoutes'

const LazyFleetMaintenanceComponent = lazy(() =>
  loadLazyWithTimeoutRetry(() => import('./FleetMaintenanceArea')),
)

const FleetMaintenanceComponent = () => (
  <SuspenseLoadingWrapper>
    <LazyFleetMaintenanceComponent />
  </SuspenseLoadingWrapper>
)

export const FleetMaintenanceArea = {
  id: FleetMaintenanceAreaId,
  requiredRight: BoumRight.AREA_FLEET_MAINTENANCE,
  NavigationComponent: FleetMaintenanceAreaNavigation,
  route: {
    path: FleetMaintenanceAreaRoutes.route,
    component: FleetMaintenanceComponent,
  },
}
